export const telemetryClientRTTI = Symbol.for("TelemetryClient");
export const telemetryClientFactoryRTTI = Symbol.for("TelemetryClientFactory");
export const telemetryEventGroupRTTI = Symbol.for("TelemetryEventGroup");
export const telemetryEventGroupFactoryRTTI = Symbol.for("TelemetryEventGroupFactory");
export const telemetryProcessorRTTI = Symbol.for("TelemetryProcessor");
export const telemetryOptionsRTTI = Symbol.for("TelemetryOptions");
export const telemetryRateLimiterOptionsRTTI = Symbol.for("TelemetryRateLimiterOptions");
